import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Alert } from 'modules/common/utils';
import { callAction, messageAction, globalAction } from 'store/action';
import { globalStateSelector } from 'store/selector';
import { CallbackScreenTheme } from 'modules/theme'

export class CallBackScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phoneNumber: ''
    };
    this.findCallback = this.findCallback.bind(this);
  }
  sendMessage(type, message) {
    const { callProcess } = this.props;
    callProcess(type, message);
  }
  findCallback( phoneNumber ) {
    const { configProcessor, dynamicUpdate } = this.props;
    dynamicUpdate({ key: 'cbListLoading', value: true })
    configProcessor(`notification:list`,{
      "page_no":1,
      "limit":100,
      "search":phoneNumber,
      "type" : "callBack",
      "orderBy" : "create_at",
      "order" : "DESC",
    });
  }
  render() {
    var _this = this;
    const { callList, callProcess, configProcessor } = this.props;
    return (
      <CallbackScreenTheme
        btnCall={'images/search.svg'}
        onNumberKeyPress={event => {
          if (event.key === 'Enter') {
            this.findCallback(event.target.value);
          }
        }}
        onNumberChange={event => {
          const re = /^[\.0-9]*$/;
          // console.log("onChange", event.target.value);
          // if (!re.test(event.target.value)) {
          //   console.log("onChange", event.target.value);
          //   return false;
          // }
          if (event.target.value || !re.test(event.target.value)) {
			  console.log('event received callback screen', event, event.target, event.target.value);
			  let value = event.target.value;
            this.setState(
				{ phoneNumber: event.target.value },
				() => this.findCallback(value)
			);
          } else {
            this.setState({ phoneNumber: "" })
          }
        }}
        onCall={event => {
          // console.log("this.state.phoneNumber", this.state.phoneNumber);
          this.findCallback(this.state.phoneNumber);
        }}
        btnKeypad={'/images/icons/ic_keypad.svg'}
        callList={callList}
        callProcess={(callInfo) => {
          console.log("Call Process Data", callInfo);
          let detail = callInfo.info && callInfo.info.detail ? callInfo.info.detail : {};
          let team   = detail.team || {};
          let custInfo   = detail.custInfo && detail.custInfo.info ? detail.custInfo.info : {};
          let messageData = {
            phoneNumber: callInfo.phoneNumber,
            teamId : callInfo.teamId,
            teamName : team.name || "",
            info : {
              leadset : detail.leadset || {},
              campaign : detail.campaign || {},
              callingMode : "callback",
              custInfo : {
                ...custInfo
              }
            },
          };
          callProcess('callInitiate', messageData);
          configProcessor('schedule:delete', {
            "scedularId": callInfo.info && callInfo.info._id ? callInfo.info._id : ""
          });
        }}
      />
    )
  }
}

CallBackScreen.contextTypes = {
  __: PropTypes.func
};
const stateToProps = state => ({
  callList: globalStateSelector.getDynamic(state, { key: 'cbList' }),
});

const dispatchToProps = dispatch => ({
  callProcess: (type, messageData) => {
    dispatch(callAction.process(type, messageData));
  },
  configProcessor: (type, messageData) => {
    dispatch(messageAction.configProcessor(type, messageData));
  },
  dynamicUpdate: data => {
    dispatch(globalAction.dynamicUpdate({ data }));
  }
});

export default connect(stateToProps, dispatchToProps)(CallBackScreen);



// WEBPACK FOOTER //
// src/dialpad/components/layout/CallBackScreen.js